import PrivateCaseAccessWatcher from './PrivateCaseAccessWatcher'

export default PrivateCaseAccessWatcher
